const MAP = {
  ativo:                   { label: 'Ativo',               cls: 'bg-success' },
  inativo:                 { label: 'Inativo',             cls: 'bg-secondary' },
  aberta:                  { label: 'Aberta',              cls: 'bg-warning text-dark' },
  em_producao:             { label: 'Em Produção',         cls: 'bg-primary' },
  parcialmente_atendida:   { label: 'Parcial',             cls: 'bg-info text-dark' },
  atendida:                { label: 'Atendida',            cls: 'bg-success' },
  pendente:                { label: 'Pendente',            cls: 'bg-warning text-dark' },
  confirmado:              { label: 'Confirmado',          cls: 'bg-primary' },
  cancelado:               { label: 'Cancelado',           cls: 'bg-danger' },
  admin:                   { label: 'Admin',               cls: 'badge-role-admin' },
  operador:                { label: 'Operador',            cls: 'badge-role-operador' },
  gestor:                  { label: 'Gestor',              cls: 'badge-role-gestor' },
  cliente:                 { label: 'Cliente',             cls: 'badge-role-cliente' },
  aberto:                  { label: 'Em aberto',           cls: 'bg-primary' },
  finalizado:              { label: 'Finalizado',          cls: 'bg-success' },
};

export default function StatusBadge({ status }) {
  const entry = MAP[status] || { label: status, cls: 'bg-secondary' };
  return <span className={`badge ${entry.cls}`}>{entry.label}</span>;
}
